export const generateIdentifier = (customer: number, user: number | string): string =>
  `customer-${customer}|user-${user}`;
